import type { UIMessage } from 'ai';

/**
 * Extracts filename labels from AI SDK user message `file` parts for transcript display.
 * Only reads `filename` on `type: 'file'` parts; other shapes fall back to `"Attachment"`.
 */
export function getUserMessageFilePartFilenames(message: UIMessage): string[] {
  const parts = message.parts;
  if (!Array.isArray(parts)) return [];
  const out: string[] = [];
  for (const p of parts) {
    if (p && typeof p === 'object' && 'type' in p && (p as { type: string }).type === 'file') {
      const raw = (p as { filename?: unknown }).filename;
      const normalized = typeof raw === 'string' ? raw.trim() : '';
      out.push(normalized || 'Attachment');
    }
  }
  return out;
}

export function formatUserBubbleAttachmentLine(attachmentFilenames: readonly string[]): string | null {
  if (attachmentFilenames.length === 0) return null;
  if (attachmentFilenames.length === 1) return `Attached: ${attachmentFilenames[0]}`;
  return `Attached: ${attachmentFilenames.join(', ')}`;
}
